var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info" },
    [
      _c(
        "el-form",
        {
          ref: "infoForm",
          staticClass: "info-form",
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c("el-form-item"),
          _c(
            "el-form-item",
            { attrs: { label: "用户头像" } },
            [
              _c("headerPicture", {
                attrs: { qrCodeUrl: _vm.form.avatarUrl },
                on: {
                  getUrl: function ($event) {
                    return _vm.getImage($event)
                  },
                },
              }),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "用户ID" } }, [
            _vm._v(" " + _vm._s(_vm.form.id) + " "),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "用户昵称", prop: "name" } },
            [
              _c("el-input", {
                staticStyle: { width: "30%" },
                on: { change: _vm.updateName },
                model: {
                  value: _vm.form.username,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "username", $$v)
                  },
                  expression: "form.username",
                },
              }),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "手机号码", prop: "name" } }, [
            _vm._v(" " + _vm._s(_vm.form.phone) + " "),
          ]),
          _c("el-form-item", { attrs: { label: " OPENID", prop: "name" } }, [
            _vm._v(" " + _vm._s(_vm.form.openId) + " "),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "用户推荐人ID", prop: "name" } },
            [_vm._v(" " + _vm._s(_vm.form.referrerUserId || "--") + " ")]
          ),
          _c(
            "el-form-item",
            { attrs: { label: " 可提现佣金", prop: "name" } },
            [_vm._v(" " + _vm._s(_vm.form.commission) + " ")]
          ),
          _c("el-form-item", { attrs: { label: "加入时间", prop: "name" } }, [
            _vm._v(" " + _vm._s(_vm.form.joinTime) + " "),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "最近访问时间", prop: "name" } },
            [_vm._v(" " + _vm._s(_vm.form.lastActiveTime) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }